/**
 * Toggle pour switcher entre le mode Wizard et Preset
 * Réservé aux utilisateurs internes
 * Composant réutilisable pour n'importe quel formulaire
 */

import { Wand2, Sparkles } from 'lucide-react';

type FormMode = 'wizard' | 'preset';

interface FormModeToggleProps {
  currentMode: FormMode;
  onToggle: (mode: FormMode) => void;
  availableModes?: FormMode[];
}

const MODE_CONFIG: Record<FormMode, { icon: typeof Wand2; label: string }> = {
  wizard: {
    icon: Wand2,
    label: 'Mode Assistant',
  },
  preset: {
    icon: Sparkles,
    label: 'Mode Preset',
  },
};

export const FormModeToggle = ({
  currentMode,
  onToggle,
  availableModes = ['wizard', 'preset']
}: FormModeToggleProps) => {
  return (
    <div className="tw-inline-flex tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-p-1 tw-shadow-sm">
      {availableModes.map((mode) => {
        const config = MODE_CONFIG[mode];
        const Icon = config.icon;

        return (
          <button
            key={mode}
            type="button"
            onClick={() => onToggle(mode)}
            className={`tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-md tw-text-sm tw-font-medium tw-transition-colors ${
              currentMode === mode
                ? 'tw-bg-affinicar-primary tw-text-white'
                : 'tw-text-gray-700 hover:tw-bg-gray-100'
            }`}
          >
            <Icon className="tw-w-4 tw-h-4" />
            {config.label}
          </button>
        );
      })}
    </div>
  );
};
